if (!window.bcpoObserver) {
  const createBCPOLabels = (container) => {
    container.querySelectorAll(".bcpo-image-parent").forEach((el, index) => {
      const { compare_at_price, price } = bcpo_product.variants[index];
      if (price < compare_at_price) {
        const badge = `
          <div class="discount-circle">
            <span>${Math.floor((100 * (compare_at_price - price)) / compare_at_price)}%</span>
          </div>`;
        el.insertAdjacentHTML("beforeend", badge);
      }
    });
  };

  const callback = (mutations) => {
    for (const mutation of mutations) {
      if (
        mutation.removedNodes.length > 0 &&
        mutation.removedNodes[0]?.classList?.contains("variant-wrapper")
      ) {
        window.bcpoObserver.disconnect();
        const el = document.querySelector("#bcpo-select-option-0");
        if (el) createBCPOLabels(el);
      }
    }
  };

  const variantWrapper = document.querySelector("[data-product-blocks]");
  window.bcpoObserver = new MutationObserver(callback);

  if (variantWrapper) {
    window.bcpoObserver.observe(variantWrapper, {
      childList: true,
      subtree: true
    });
  }

  setTimeout(() => {
    const el = document.querySelector("#bcpo-select-option-0");
    if (el) createBCPOLabels(el);
  }, 2000);
}